var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0013 2H11.3346V10.6667L6.66797 15.3333L5.83464 14.5C5.75686 14.4222 5.69297 14.3167 5.64297 14.1833C5.59297 14.05 5.56797 13.9222 5.56797 13.8V13.5667L6.3013 10.6667H2.0013C1.64575 10.6667 1.33464 10.5333 1.06797 10.2667C0.801302 10 0.667969 9.68889 0.667969 9.33333V8C0.667969 7.92222 0.67908 7.83889 0.701302 7.75C0.723524 7.66111 0.745747 7.57778 0.767969 7.5L2.76797 2.8C2.86797 2.57778 3.03464 2.38889 3.26797 2.23333C3.5013 2.07778 3.74575 2 4.0013 2ZM10.0013 3.33333H4.0013L2.0013 8V9.33333H8.0013L7.1013 13L10.0013 10.1V3.33333ZM11.3346 10.6667V9.33333H13.3346V3.33333H11.3346V2H14.668V10.6667H11.3346Z",
    fill: "#586C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsThumbsDown);
export default __webpack_public_path__ + "static/media/icons_thumbs_down.38f5c30a.svg";
export { ForwardRef as ReactComponent };